import React, { useCallback, useEffect, useState } from "react"
import {
    AlertType, Conta, ContasSearchBox, LanctoContaPag, ParamsLiqDupPagar, classBorderLabelDark, classBt, classInput, classInputDark, classLabel,
    classLabelDark, classbtAzul, classbtColunasVermelho, classbtVerde, classbtVermelho
} from "../../Utils/Types"
import { Funcoes } from "../../Utils/Funcoes"
import { DataSearch, SearchBox } from "../SearchBox/SearchBox"
import { ContaAPagarService } from "../../Pages/ContasAPagar/ContaAPagarService"
import moment from "moment"
import { FeedbackMessage } from "../FeedbackMessage/feedback-message"
import { FaPlus, FaTrash, FaTrashAlt } from "react-icons/fa"
import { HiDocumentArrowDown, HiDocumentCheck } from "react-icons/hi2"
import { ContaService } from "../../Pages/Contas/ContasService"

export type Props = {
    visible: boolean,
    totSelecionado: number,
    handleModalClose: () => void,
    handleConfirm: () => Promise<boolean>,
    dupSelectedList: number[],
}

export const ModalLiqDup = React.memo(({ visible, handleModalClose, handleConfirm, dupSelectedList, totSelecionado }: Props) => {

    let attr = {
        contaAPagar: {
            id: 0,
            id_fornecedor: 0,
            id_grupo_despesa: 0,
            dt_vencimento: '',
            dt_liquidacao: '',
            nome_fornecedor: '',
            desc_grupo_despesa: '',
            valor: 0,
            num_doc: '',
            serie: 0,
            observacao: '',
            id_bordero: 0
        },
        fornecedor: [], grupoDespesa: [], contas: [],
    }

    // ---------- ATRIBUTOS FEEDBACK ---------------------------------------------
    const [loading, setLoading] = useState<boolean>(false)
    const [feedbackVisible, setFeedbackVisible] = useState<boolean>(false)
    const [feedbackMessage, setFeedbackMessage] = useState("")
    const [feedbackType, setFeedbackType] = useState<AlertType>("DANGER")


    // ---------- ATRIBUTOS  -----------------------------------------------------
    const [dataPagto, setDataPagto] = useState(moment().format("YYYY-MM-DD"))
    const [senhaUsuario, setSenhaUsuario] = useState("")
    const [vlDesconto, setVlDesconto] = useState<string>("0,00")
    const [vlOutros, setVlOutros] = useState<string>("0,00")
    const [vlPagar, setVlPagar] = useState<string>("0,00")
    const [valor_restante_original, setValor_Restante_Origianl] = useState("0,00")
    const [valor_restante, setValor_Restante] = useState("0,00")
    const [vlTotalSelecionado, setVlTotalSelecionado] = useState<string>("0,00")
    const [observacao, setObservacao] = useState("")


    // --------------- ATRIBUTOS LANCAMENTO CONTAS ----------------------------
    const [lanctoContasList, setLanctoContasList] = useState<LanctoContaPag[]>([])
    const [idConta, setIdConta] = useState<number>(0)
    const [contas, setContas] = useState<ContasSearchBox[]>([])
    const [contasList, setContasList] = useState<ContasSearchBox[]>([])
    const [valorConta, setValorConta] = useState("0,00")
    const [descConta, setDescConta] = useState("")

    // -----------------------------------------------
    // ------------- SEARCH BOX ----------------------
    // -----------------------------------------------
    const [visibleSearchBoxContas, setVisibleSearchBoxContas] = useState<boolean>(false)


    //------------------------------------------------------------------- ATRIBUTOS E EFFECT ------------------------------------------------------------------------||
    const getAttributes = async () => {

        setFeedbackVisible(false)
        setLoading(true)

        try {


            const Attributes = await ContaService.GetListConta()
            setContasList(Attributes.data)

            //const Attributes = await ContaAPagarService.GetAttributes()
            //setAttributes(Attributes.data)
            //setGDespesaList(Attributes.data.grupoDespesa)
            //setContas(Attributes.data.contas)

            //const attributesConta = await LanctoCaixaService.GetAttributes()
            //setContasFilter(attributesConta)

        } catch (error) {

            setFeedbackVisible(true)
            setFeedbackType("DANGER")
            setFeedbackMessage("Não foi possível buscar os dados")

        } finally {
            setLoading(false)
        }

    }

    useEffect(() => {
        calcularVlPagarLiq()
    }, [vlDesconto, vlOutros])

    useEffect(() => {

        if (visible) {

            setLanctoContasList([])
            setVlPagar(Funcoes.numberFormat(totSelecionado || '0', 'decimal', 2, 2))
            setVlTotalSelecionado(Funcoes.numberFormat(totSelecionado || '0', 'decimal', 2, 2))
            setValor_Restante_Origianl(Funcoes.numberFormat(totSelecionado || '0', 'decimal', 2, 2))

            getAttributes()

            let modal = document.getElementById('modal_duplicata_liq')
            let modalContent = document.getElementById('modal_content_dup_liq')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-1000px]')
                    modalContent.classList.add('mt-20')
                }
            }

        } else {

            let modal = document.getElementById('modal_duplicata_liq')
            let modalContent = document.getElementById('modal_content_dup_liq')

            if (modal) {
                modal.style.visibility = 'hidden'

                if (modalContent) {
                    modalContent.classList.add('mt-[-1000px]')
                    modalContent.classList.remove('mt-20')
                }
            }

            handleInputFocus()
        }

    }, [visible])

    useEffect(() => {

        // soma total da lista
        const valorLista = lanctoContasList.reduce((acc, item) => acc + Number(item.valor || 0), 0);

        // valor restante original (convertido corretamente para número)
        const valorOriginal = parseFloat(valor_restante_original.replaceAll(".", "").replace(",", ".")) || 0;

        // valor restante atualizado
        const valorRestante = valorOriginal - valorLista - parseFloat(vlDesconto) + parseFloat(vlOutros);

        // seta no state já formatado
        setValor_Restante(Funcoes.numberFormat(valorRestante, 'decimal', 2, 2));

    }, [lanctoContasList, vlDesconto, vlOutros]); // dependência é a lista inteira, não só o length

    const handleInputFocus = () => {
        setVisibleSearchBoxContas(false)
    }

    //--------------------------------------------------------------------------------------------- INPUTS ------------------------------------------------------------------------------------------//
    const handleChangeDataPagto = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataPagto(e.target.value)
    }

    const handleChangeSenhaUsuario = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSenhaUsuario(e.target.value)
    }

    const handleChangeVlDesconto = (e: React.ChangeEvent<HTMLInputElement>) => {
        setVlDesconto(Funcoes.MaskMoney(e.target.value))
    }

    const handleChangeVlOutros = (e: React.ChangeEvent<HTMLInputElement>) => {
        setVlOutros(Funcoes.MaskMoney(e.target.value))
    }

    const handleChangeVlPagar = (e: React.ChangeEvent<HTMLInputElement>) => {
        setVlPagar(Funcoes.MaskMoney(e.target.value))
    }

    const handleChangeObservacao = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setObservacao(e.target.value)
    }

    //--------------------------------------------------------------------------------------------- CONTAS ------------------------------------------------------------------------------------------//
    const handleClearContaClick = useCallback(() => {

        setIdConta(0)
        setVisibleSearchBoxContas(false)

    }, [contasList])

    const handleContaSelected = useCallback((conta: ContasSearchBox) => {

        if (conta) {

            setIdConta(conta.id)
            setDescConta(conta.description)
        }

        setVisibleSearchBoxContas(false)

    }, [contasList])

    const handleFilterContaClick = useCallback((description: string) => {

        if (description === "") {

            const newContas = [...contasList]
            setContas(newContas)

        } else {

            const newContas = [...contasList || []].filter((conta) => {
                return conta.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })

            setContas(newContas || [])
        }
    }, [contasList])

    const handleChangeValorConta = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValorConta(Funcoes.MaskMoney(e.target.value))
    }

    const handleAddContaListClick = () => {

        setFeedbackVisible(false)

        let newLanctoContasList = lanctoContasList.filter(it => it.id_conta === idConta)

        if (parseFloat(valorConta) <= 0 || isNaN(parseFloat(valorConta))) {

            const timer = setTimeout(() => {
                setFeedbackVisible(true)
                setFeedbackType("DANGER")
                setFeedbackMessage("Valor da conta inválido")
                clearTimeout(timer)
            }, 250)
            return
        }

        if (idConta === 0) {

            const timer = setTimeout(() => {
                setFeedbackVisible(true)
                setFeedbackType("DANGER")
                setFeedbackMessage("Conta não informada")
                clearTimeout(timer)
            }, 250)
            return
        }

        if (newLanctoContasList.length > 0) {

            const timer = setTimeout(() => {
                setFeedbackVisible(true)
                setFeedbackType("DANGER")
                setFeedbackMessage("Conta já lançada")
                clearTimeout(timer)
            }, 250)
            return
        }

        const lanctoConta: LanctoContaPag = {
            id_conta: idConta,
            description: descConta,
            valor: parseFloat(valorConta)
        };

        setLanctoContasList(prev => [...prev, lanctoConta]);

        setIdConta(0)
        setDescConta("")
        setValorConta("0.00")
    }

    const handleRemoveContaListClick = (item: LanctoContaPag) => {
        setLanctoContasList(prev => prev.filter(it => it.id_conta !== item.id_conta));
    }

    const clickSearchBoxContas = useCallback(() => {
        setVisibleSearchBoxContas((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {

                inputFocusContas()
            }
            return newState
        })
    }, [])

    const inputFocusContas = () => {
        let inputSearch = document.getElementById(`inputSearchBox-contas`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }


    //---------------------------------------------------------------------------------------------  LIQUIDAR DUPLICATAS ------------------------------------------------------------------------------------------//
    const calcularVlPagarLiq = () => {
        let outros = vlOutros
        let desconto = vlDesconto

        outros = vlOutros.replaceAll(",", ".")
        desconto = desconto.replaceAll(",", ".")

        setVlPagar(Funcoes.numberFormat(totSelecionado - parseFloat(desconto) + parseFloat(outros)))
    }

    const handleLiquidarDuplicata = async () => {

        setFeedbackVisible(false)
        setLoading(true)

        try {

            const parametros: ParamsLiqDupPagar = {
                dtpagto: '',
                observacao: '',
                vl_desc: 0,
                vl_outros: 0,
                vl_bruto: 0,
                vl_pagar: 0,
                senha_usuario: '',
                duplicatas: [],
                lanctoContasList: lanctoContasList,
            }

            let valorBaixar = lanctoContasList.reduce((acc, item) => acc + item.valor, 0);
            valorBaixar = Math.round(valorBaixar * 100) / 100; // mantém como número

            parametros.dtpagto = dataPagto
            parametros.observacao = observacao
            parametros.vl_bruto = totSelecionado
            parametros.vl_desc = parseFloat(vlDesconto)
            parametros.vl_outros = parseFloat(vlOutros)
            parametros.vl_pagar = valorBaixar
            parametros.senha_usuario = senhaUsuario
            parametros.duplicatas = dupSelectedList

            //console.log("parametros: ", parametros)

            const retAPI = await ContaAPagarService.LiquidarDuplicatas(parametros)

            if (retAPI.error) {

                const timer = setTimeout(() => {
                    setFeedbackVisible(true)
                    setFeedbackType("DANGER")
                    setFeedbackMessage(retAPI.msg || '')
                    clearTimeout(timer)
                }, 250)

            } else {

                setFeedbackVisible(true)
                setFeedbackType("SUCCESS")
                setFeedbackMessage("Duplicata liquidada com sucesso")

                const dados = await handleConfirm()

                if (dados) {
                    const aguarde = setTimeout(() => {
                        clearFields()
                        handleModalClose()
                        clearTimeout(aguarde)
                    }, 250)
                }
            }


        } catch (error) {

            setFeedbackVisible(true)
            setFeedbackType("DANGER")
            setFeedbackMessage("Não foi possível liquidar a(s) duplicata(s). Por favor, tente novamente")

        } finally {
            setLoading(false)
        }

    }

    const clearFields = () => {

        setSenhaUsuario('')
        setVlOutros("0,00")
        setVlDesconto("0,00")
        setVlPagar("0,00")
        setVlTotalSelecionado("0,00")
        setValor_Restante("0,00")
        setValor_Restante_Origianl("0,00")
        setIdConta(0)
        setValorConta('')
        setDescConta('')
        setLanctoContasList([])
        setObservacao('')
    }

    const fecharModal = () => {

        setFeedbackVisible(false)
        handleModalClose()

        setSenhaUsuario('')
        setVlOutros("0,00")
        setVlDesconto("0,00")
        setVlPagar("0,00")
        setVlTotalSelecionado("0,00")
        setIdConta(0)
        setValorConta('')
        setDescConta('')
        setLanctoContasList([])
        setObservacao('')
        //setVlPagarLiq(0)
        //setIdGDespesa(0)
    }

    const handleCloseMessage = () => {
        setFeedbackVisible(false)
    }

    return (

        <div id="modal_duplicata_liq" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40`}>

            <div id="modal_content_dup_liq" className={`relative flex flex-col w-[90%] 2xl:w-[70%] h-[500px] bg-white dark:bg-slate-600 rounded-lg mt-[-1000px] transition-all duration-300 justify-center items-center`}>

                <FeedbackMessage visible={feedbackVisible} message={feedbackMessage} type={feedbackType} onCloseMessage={handleCloseMessage} />

                <div className={`absolute top-0 w-full h-[70px] flex items-center`}>

                    <div className={`ml-4 flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>
                        <HiDocumentCheck className={`w-5 h-5 text-slate-700 dark:text-slate-200`} />
                    </div>
                    <span className={`mx-2 text-base font-semibold leading-6 text-slate-700 dark:text-slate-200`}>Liquidar Duplicatas a Pagar</span>

                </div>

                <div className={`absolute top-[70px] bottom-[60px] w-full`}>

                    <div className={`grid grid-cols-12 gap-3 bg-white dark:bg-slate-600 py-3 h-full overflow-y-auto px-2`}>

                        <div className={`col-span-12 lg:col-span-6`}>

                            <div className={`grid grid-cols-12 gap-3`}>

                                <div className={`relative col-span-12 sm:col-span-4 lg:col-span-6 xl:col-span-4 mt-2`}>
                                    <input id="valor_bruto_dup_pagar" className={`${classInput} ${classInputDark} disabled:bg-slate-200 dark:disabled:bg-slate-700 disabled:cursor-not-allowed`} type='text' disabled={true} placeholder=' ' value={vlTotalSelecionado} readOnly />
                                    <label htmlFor="valor_bruto_dup_pagar" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor Bruto (R$)</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-4 lg:col-span-6 xl:col-span-4 mt-2`}>
                                    <input id="total_liquidar_dup_pagar" className={`${classInput} ${classInputDark} disabled:bg-slate-200 dark:disabled:bg-slate-700 disabled:cursor-not-allowed`} type="text" disabled={true} placeholder=' ' value={vlPagar} readOnly />
                                    <label htmlFor="total_liquidar_dup_pagar" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Total a Liquidar (R$)</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-4 lg:col-span-6 xl:col-span-4 mt-2`}>
                                    <input id="total_restante_dup_pagar" type='text' disabled={true} className={`${classInput} ${classInputDark} disabled:bg-slate-200 dark:disabled:bg-slate-700 disabled:cursor-not-allowed`} placeholder=' ' value={valor_restante} readOnly />
                                    <label htmlFor="total_restante_dup_pagar" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor Restante (R$)</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-4 lg:col-span-6 xl:col-span-4 mt-2`}>
                                    <input id="data_pagto_dup_pagar" className={`${classInput} ${classInputDark} ${dataPagto === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" disabled={true} value={dataPagto} onFocus={handleInputFocus} onChange={handleChangeDataPagto} />
                                    <label htmlFor="data_pagto_dup_pagar" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>* Data do Pagamento</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-4 lg:col-span-6 xl:col-span-4 mt-2`}>
                                    <input id="vl_juros_dup_pagar" className={`${classInput} ${classInputDark}`} type='text' inputMode="numeric" placeholder=' ' autoComplete="off" value={vlOutros} onFocus={handleInputFocus} onChange={handleChangeVlOutros} />
                                    <label htmlFor="vl_juros_dup_pagar" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Juros (R$)</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-4 lg:col-span-6 xl:col-span-4 mt-2`}>
                                    <input id="vl_desconto_dup_pagar" className={`${classInput} ${classInputDark}`} type='text' inputMode="numeric" placeholder=' ' autoComplete="off" value={vlDesconto} onFocus={handleInputFocus} onChange={handleChangeVlDesconto} />
                                    <label htmlFor="vl_desconto_dup_pagar" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Desconto (R$)</label>
                                </div>

                                <div className={`relative col-span-12 mt-2`}>
                                    <input id='senha_usuario_dup_pagar' className={`${classInput} ${classInputDark}`} type='password' inputMode="text" placeholder=' ' autoComplete="off" value={senhaUsuario} onFocus={handleInputFocus} onChange={handleChangeSenhaUsuario} />
                                    <label htmlFor="senha_usuario_dup_pagar" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>* Senha do usuário</label>
                                </div>

                                <div className={`relative col-span-12 mt-2`}>
                                    <textarea id='observacao_dup_pagar' className={`${classInput} ${classInputDark} h-[130px] lg:h-[60px] 2xl:h-[130px] resize-none`} inputMode="text" maxLength={155} placeholder=' ' autoComplete="off" value={observacao} onFocus={handleInputFocus} onChange={handleChangeObservacao} />
                                    <label htmlFor="observacao_dup_pagar" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Observação</label>
                                </div>

                            </div>

                        </div>

                        {/* Lançamento de contas */}
                        <div className={`col-span-12 lg:col-span-6 h-[500px] sm:h-[350px] border border-slate-400 dark:border-slate-700 rounded-sm px-2`}>

                            <div className={`grid grid-cols-12 gap-3 mt-3 space-y-1 md:space-y-0`}>

                                <div className={`relative col-span-12 md:col-span-6 lg:col-span-6`}>
                                    <SearchBox
                                        dataList={contas}
                                        idRegistro={idConta}
                                        label="Conta"
                                        componentId="contas"
                                        visibleTAB={visibleSearchBoxContas}
                                        setDataClick={handleContaSelected}
                                        clearDataClick={handleClearContaClick}
                                        filterDataClick={handleFilterContaClick}
                                        clicado={clickSearchBoxContas}
                                    />
                                </div>

                                <div className={`relative col-span-12 sm:col-span-9 md:col-span-4 lg:col-span-4`}>
                                    <input id='valor_conta' className={`${classInput} ${classInputDark}`} type='text' inputMode="numeric" placeholder=' ' autoComplete="off" value={valorConta} onFocus={handleInputFocus} onChange={handleChangeValorConta} />
                                    <label htmlFor="valor_conta" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-3 md:col-span-2 lg:col-span-2`}>
                                    <button className={` ${classBt} ${classbtVerde}`} onFocus={handleInputFocus} onClick={handleAddContaListClick}>
                                        <FaPlus className={`w-3 h-3`} />
                                    </button>
                                </div>

                                <div className={`relative col-span-12 mt-1`}>

                                    <div className={`w-full`}>
                                        <ul className={`w-full h-full dark:bg-slate-500 text-slate-700 dark:text-white`}>
                                            <li className={`h-10`}>
                                                <div className={`w-full flex flex-row h-10 text-sm`}>
                                                    <div className={`flex items-center justify-start w-[60%] h-full border border-slate-300 dark:border-slate-700`}>
                                                        <span className={`px-1`}>Conta</span>
                                                    </div>
                                                    <div className={`flex items-center justify-end w-[30%] h-full border border-slate-300 dark:border-slate-700`}>
                                                        <span className={`px-1`}>Valor</span>
                                                    </div>
                                                    <div className={`flex items-center justify-center w-[10%] h-full border border-slate-300 dark:border-slate-700`}>
                                                        <span className={`px-1`}>[X]</span>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className={`overflow-auto h-full max-h-[1000px] scrollbar-custom dark:scrollbar-custom-dark`}>

                                        <div className={`w-full`}>

                                            <ul className={`w-full`}>
                                                {lanctoContasList.length > 0 &&
                                                    lanctoContasList.map((item) => (
                                                        <li key={item.id_conta} className={`w-full h-auto hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all`}>

                                                            <div className={`w-full flex flex-row h-[40px] text-sm break-all text-black dark:text-slate-200`}>

                                                                <div className={`flex items-center justify-start w-[60%] border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-1`}>{item.description}</span>
                                                                </div>

                                                                <div className={`flex items-center justify-end w-[30%] border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-1`}>{Funcoes.numberFormat(item.valor, 'currency', 2, 2)}</span>
                                                                </div>

                                                                <div className={`flex items-center justify-center w-[10%] border border-slate-300 dark:border-slate-700`}>
                                                                    <button className={`flex items-center justify-center w-6 h-6 rounded-sm text-white transition-all duration-150 ${classbtVermelho}`}
                                                                        onClick={() => handleRemoveContaListClick(item)}>
                                                                        <FaTrashAlt className="w-3 h-3" />
                                                                    </button>
                                                                </div>

                                                            </div>
                                                        </li>
                                                    ))
                                                }
                                            </ul>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>
                        {/* Lançamento de contas */}

                    </div>

                </div>

                {loading &&

                    <div className={`absolute top-[70px] bottom-[60px] w-full pt-4 bg-slate-300 dark:bg-slate-700 bg-opacity-30 dark:bg-opacity-30 flex justify-center items-center`}>

                        <div className={`h-[60px] w-[60px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-cyan-600 dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                        </div>

                    </div>
                }

                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>

                    <button
                        disabled={loading}
                        onClick={fecharModal}
                        className={`${classbtColunasVermelho} max-w-[150px]`} >
                        CANCELAR
                    </button>

                    <button
                        disabled={loading}
                        onClick={handleLiquidarDuplicata}
                        className={`${classbtAzul} ${classBt} max-w-[150px]`}>
                        {loading &&
                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-white dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                            </div>
                        }

                        {/*
                        {!loading &&
                            <FaCloudArrowDown className="w-5 h-5 mx-1 text-white" />
                        }
                        */}
                        {!loading ? `LIQUIDAR` : "AGUARDE"}
                    </button>

                </div>

            </div>

        </div>
    )
})